import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ClearableInput from '../clearableInput/ClearableInput';
const TreeSearch = React.memo(props => {
    const { value, className, placeholder, onChange } = props;
    const classes = classNames('TreeSearch', className);
    return (_jsx("div", Object.assign({ className: classes }, { children: _jsxs("div", Object.assign({ className: 'input-group flex-1-0' }, { children: [_jsx("span", Object.assign({ className: 'input-group-addon' }, { children: _jsx("span", { className: 'rioglyph rioglyph-search', "aria-hidden": 'true' }) })), _jsx(ClearableInput, { value: value, onChange: onChange, placeholder: placeholder })] })) })));
});
TreeSearch.displayName = 'TreeSearch';
TreeSearch.defaultProps = {
    onChange: () => { },
};
TreeSearch.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    className: PropTypes.string,
};
export default TreeSearch;
